module.exports = __webpack_public_path__ + "img/dfba7a303894b9f896cffc9529ee1eb5.png";